import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=70ea366a&scoped=true&lang=pug&"
import script from "./CustomersView.vue?vue&type=script&lang=js&"
export * from "./CustomersView.vue?vue&type=script&lang=js&"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=70ea366a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea366a",
  null
  
)

export default component.exports